import React, { Component } from 'react';
import '../css/project-read-more-modal.css';

class ProjectReadMoreModal extends Component {

    componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
        document.body.style.overflow = 'hidden';
    } else if (!this.props.isOpen && prevProps.isOpen) {
        document.body.style.overflow = '';
    }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    render() { 
        const { isOpen, onClose, title, description } = this.props;

        if (!isOpen) return null;

        return (
            <div className='readMoreModal'>
                <div className="modal-backdrop" onClick={onClose}></div>
                <div className="modal-content">
                    <div className="modal-header">
                        <h2>{title}</h2>
                        <button className="close-button" onClick={onClose}>×</button>
                    </div>
                    <div className="modal-body">
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default ProjectReadMoreModal;